import type { TypographyVariantsOptions } from "@mui/material";
import * as polished from "polished";

import { defaultFontFamily } from "./fontFamily.ts";

export const typography: TypographyVariantsOptions = {
  fontFamily: defaultFontFamily,
  h1: {
    fontSize: polished.rem(24),
    fontWeight: 700,
    lineHeight: polished.rem(34),
  },
  h2: {
    fontSize: polished.rem(20),
    fontWeight: 600,
    lineHeight: polished.rem(28),
  },
  h3: {
    fontSize: polished.rem(16),
    fontWeight: 600,
    lineHeight: polished.rem(24),
  },
  h4: {
    fontSize: polished.rem(15),
    fontWeight: 600,
    lineHeight: polished.rem(22),
  },
  body1: {
    fontSize: polished.rem(15),
    fontWeight: 400,
    lineHeight: polished.rem(24),
  },
  body2: {
    fontSize: polished.rem(14),
    fontWeight: 400,
    lineHeight: polished.rem(22),
  },
  body3: {
    fontSize: polished.rem(13),
    fontWeight: 400,
    lineHeight: polished.rem(20),
  },
  button: {
    fontSize: polished.rem(14),
    fontWeight: 600,
    lineHeight: polished.rem(22),
    textTransform: "none",
  },
  overline: {
    fontSize: polished.rem(14),
    fontWeight: 600,
    lineHeight: polished.rem(22),
    textTransform: "uppercase",
  },
};
